module.exports = __webpack_public_path__ + "img/icons/right-arrow-grey-7c9aa717254cf560d4a96d6edd6215ad.svg";